<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-servico')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-servico')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="dynamicRules" ref="ruleForm" label-position="top">
        <el-form-item :label="$t('tipo-servico')" prop="type">
          <el-radio-group v-model="ruleForm.type">
            <el-radio-button label="1">Serviço ECT</el-radio-button>
            <el-radio-button label="2">Transportadora</el-radio-button>
            <el-radio-button label="3">Taxa</el-radio-button>
            <el-radio-button label="4">Logistica Reversa</el-radio-button>
            <el-radio-button label="5">Carta</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('grupo-servico')" prop="servicesgroup">
          <ServicesGroupList v-model="ruleForm.servicesgroup" v-bind:current="ruleForm.servicesgroup" />
        </el-form-item>
        <el-form-item :label="$t('transportadora')" prop="shiiping" v-show="ruleForm.type === '2'">
          <ShippingList v-model="ruleForm.shipping" v-bind:current="ruleForm.shipping" @selected="handleEuEntregoServices" />
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('codigo')" prop="code">
              <el-input ref="code" :disabled="id !== ''" v-model="ruleForm.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('nome')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('cod-modalidade')" prop="modalityCode">
              <el-input ref="modalityCode" v-model="ruleForm.modalityCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <!-- Reversa Consolidada (TASK-1808): logística reversa + malha = posta com o serviço normal -->
            <el-form-item
              :label="reverseConsolidated ? 'Serviço de postagem (Reversa Consolidada)' : $t('logistica-reversa')"
              prop="reverseCode"
            >
              <ServicesCode v-if="reverseConsolidated" v-model="ruleForm.reverseCode" :current="ruleForm.reverseCode" />
              <ReverseLogisticsList v-else v-model="ruleForm.reverseCode" :current="ruleForm.reverseCode" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item label="Código Cotação" prop="plpCode">
              <ServicesCode v-model="ruleForm.plpCode" :current="ruleForm.plpCode" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item prop="reverseCode">
              <el-checkbox v-model="ruleForm.reserveTags" autocomplete="off">{{ $t('utiliza-reserva-etiquetas')
                }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item prop="same">
              <el-checkbox v-model="ruleForm.same" autocomplete="off">{{ $t('utiliza-o-mesmo-valor-correios')
                }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="3" :xl="3">
            <el-form-item prop="cobrarRoyalty">
              <el-checkbox v-model="ruleForm.cobrarRoyalty" autocomplete="off">{{ $t('cobrar-royalty')
                }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="3" :xl="3">
            <el-form-item prop="malha">
              <el-checkbox v-model="ruleForm.malha" autocomplete="off">{{ $t('considera-malha')
              }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="3" :xl="3">
            <el-form-item prop="dce">
              <el-checkbox v-model="ruleForm.dce" autocomplete="off">Emite DC-E</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="5" v-show="isEuEntregoFields">
          <el-col :xs="24" :sm="24" :md="16" :lg="10" :xl="10">
            <el-form-item label="Authorization Token" prop="authorizationToken">
              <el-input v-model="ruleForm.authorizationToken"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="5">
          <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
            <el-form-item :label="$t('tipo-carta')" prop="letter">
              <el-select v-model="ruleForm.letter" :disabled="ruleForm.type !== '5'"
                :placeholder="$t('selecione-uma-opcao')">
                <el-option key="1" label="CR" value="1"></el-option>
                <el-option key="2" label="CR+AR" value="2"></el-option>
                <el-option key="3" label="CR+MP" value="3"></el-option>
                <el-option key="4" label="CR+AR+MP" value="4"></el-option>
                <el-option key="5" label="CR+AR-E" value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('valor')" prop="value" v-if="ruleForm.type === '3'">
          <el-input-number v-model="ruleForm.value" :precision="2" :step="0.1"></el-input-number>
        </el-form-item>

        <el-form-item :label="$t('altura-cm')" prop="heightmin" :required="true">
          Min
          <el-input-number size="small" v-model="ruleForm.heightmin" :disabled="isEuEntregoFields"></el-input-number>
          Max
          <el-input-number size="small" v-model="ruleForm.heightmax" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('largura-cm')" prop="widthmin" :required="true">
          Min
          <el-input-number size="small" v-model="ruleForm.widthmin" :disabled="isEuEntregoFields"></el-input-number>
          Max
          <el-input-number size="small" v-model="ruleForm.widthmax" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('comprimento-cm')" prop="lengthmin" :required="true">
          Min
          <el-input-number size="small" v-model="ruleForm.lengthmin" :disabled="isEuEntregoFields"></el-input-number>
          Max
          <el-input-number size="small" v-model="ruleForm.lengthmax" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('peso-g')" prop="weightmin" :required="true">
          <span v-if="!isEuEntregoFields">
            Min
            <el-input-number size="small" v-model="ruleForm.weightmin"></el-input-number>
          </span>
          Max
          <el-input-number size="small" v-model="ruleForm.weightmax" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('valor-declarado')" prop="valuemin" :required="true">
          <span v-if="!isEuEntregoFields">
            Min
            <el-input-number size="small" v-model="ruleForm.valuemin"></el-input-number>
          </span>
          Max
          <el-input-number size="small" v-model="ruleForm.valuemax" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('valor-max-sem-nota')" prop="valuemaxnf" :required="true">
          Max
          <el-input-number size="small" v-model="ruleForm.valuemaxnf" :disabled="isEuEntregoFields"></el-input-number>
        </el-form-item>
        <el-form-item v-if="id !== '' && ruleForm.type === '1' && aditionalsLoaded" label="Serviços adicionais (Correios)">
          <el-table :data="aditionals" size="mini" border style="width: 100%" empty-text="Nenhum serviço adicional encontrado">
            <el-table-column prop="code" label="Código" width="90"></el-table-column>
            <el-table-column prop="acronym" label="Sigla" width="90"></el-table-column>
            <el-table-column prop="name" label="Nome" min-width="220"></el-table-column>
            <el-table-column label="Preço" width="110">
              <template slot-scope="scope">{{ formatMoney(scope.row.price) }}</template>
            </el-table-column>
            <el-table-column label="Mínimo" width="230">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="scope.row.minimun" :min="0" :precision="2" :step="1" controls-position="right"></el-input-number>
                <el-button size="mini" type="warning" icon="el-icon-check" circle @click="saveAditional(scope.row)"></el-button>
              </template>
            </el-table-column>
            <el-table-column label="Máximo" width="120">
              <template slot-scope="scope">{{ formatMoney(scope.row.maximun) }}</template>
            </el-table-column>
            <el-table-column label="Vigência" width="190">
              <template slot-scope="scope">{{ formatDate(scope.row.validatyStartAt) }} - {{ formatDate(scope.row.validatyEndAt) }}</template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
            }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
            }}</el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
import { i18n } from "@/plugin/i18n";
import ServicesGroupList from "@/xpost/views/register/services.group/ServicesGroupList";
import ReverseLogisticsList from "../../services/reverse.logistics/ReverseLogisticsList";
import ShippingList from "../shipping/ShippingList";
import ServicesCode from './ServicesCode';

export default {
  name: "ServiceAdd",
  components: {
    ServicesGroupList,
    ReverseLogisticsList,
    ServicesCode,
    ShippingList,
  },
  data() {
    return {
      imageUrl: "",
      id: "",
      isEuEntregoFields: false,
      aditionals: [],
      aditionalsLoaded: false,
      ruleForm: {
        name: "",
        code: "",
        token: "",
        reverseCode: "",
        shipping: "",
        plpCode: "",
        postoffice: false,
        same: false,
        reserveTags: true,
        servicesgroup: "",
        letter: "",
        type: "1",
        value: 0,
        lengthmin: 0,
        lengthmax: 0,
        widthmin: 0,
        widthmax: 0,
        heightmin: 0,
        heightmax: 0,
        weightmin: 0,
        weightmax: 0,
        valuemin: 0,
        valuemax: 0,
        valuemaxnf: 0,
        cobrarRoyalty: true,
        malha: true,
        dce: false,
        modalityCode: "",
        authorizationToken: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: i18n.tc("codigo-obrigatorio"),
            trigger: "blur",
          },
        ],
        servicesgroup: [
          {
            required: true,
            message: "Grupo do serviço",
            trigger: "blur",
          },
        ],
        valuemaxnf: [
          {
            required: true,
            message: i18n.tc("campo-obrigatorio"),
          },
        ],
      },
    };
  },
  computed: {
    reverseConsolidated() {
      return this.ruleForm.type === "4" && this.ruleForm.malha === true;
    },
    dynamicRules() {
      const rules = { ...this.rules };
      if (this.isEuEntregoFields) {
        rules.authorizationToken = [
          {
            required: true,
            message: "Authorization Token is required",
            trigger: "blur",
          },
        ];
      } else {
        delete rules.authorizationToken;
      }
      return rules;
    }
  },
  methods: {
    handleEuEntregoServices(shipping) {
      var vm = this;

      const euEntregoRegex = /eu.*entrego/i;
      const isEuEntrego = shipping && shipping.name && euEntregoRegex.test(shipping.name) && vm.ruleForm.type === "2";

      vm.isEuEntregoFields = isEuEntrego;

      if (!isEuEntrego) {
        vm.ruleForm.weightmax = 0;
        vm.ruleForm.valuemax = 0;
        vm.ruleForm.heightmax = 0;
        vm.ruleForm.lengthmax = 0;
        vm.ruleForm.widthmax = 0;
        return;
      }

      vm.ruleForm.weightmax = 20000;
      vm.ruleForm.valuemax = 2000;
      vm.ruleForm.heightmax = 100;
      vm.ruleForm.lengthmax = 100;
      vm.ruleForm.widthmax = 100;
    },
    back() {
      var vm = this;
      vm.$router.replace({ name: "services" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ServicesService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
          vm.ruleForm.servicesgroup = response.servicegroup
            ? response.servicegroup.id
            : "";

          if (response.file) {
            vm.ruleForm.token = response.file.token;
            vm.imageUrl = response.file.url;
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    getAditional() {
      const vm = this;
      ServicesService.aditional(vm.id)
        .then((response) => {
          vm.aditionals = (response || []).map((x) => ({ ...x, minimun: +x.minimun || 0 }));
          vm.aditionalsLoaded = true;
        })
        .catch(() => {
          // usuário sem permissão ou erro na consulta: não exibe a tabela de adicionais
          vm.aditionalsLoaded = false;
        });
    },
    saveAditional(row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ServicesService.updateAditional(vm.id, row.id, +row.minimun)
        .then((response) => {
          row.minimun = +response.minimun || 0;
          vm.$message({
            type: "success",
            message: `Valor mínimo do adicional ${row.code} atualizado!`,
          });
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    formatMoney(value) {
      return Intl.NumberFormat("pt-br", { style: "currency", currency: "BRL" }).format(+value || 0);
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString("pt-br") : "";
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.ruleForm.type == "3" && vm.ruleForm.value == 0) {
            return vm.$message({
              type: "error",
              message:
                "É obrigatório informar um valor para o tipo de serviço de taxa!",
            });
          }
          const loading = vm.$loading(vm.$options.loading);
          ServicesService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("servico-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      console.log('😎', vm.ruleForm);
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ServicesService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("servico-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
      vm.getAditional();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>